import dynamic from 'next/dynamic';

const AwardsGallery = dynamic(() => import('./organisms/AwardsGallery/AwardsGallery').then(mod => mod.AwardsGallery));
const CardFeatures = dynamic(() => import('./organisms/CardFeatures/CardFeatures').then(mod => mod.CardFeatures));
const InternationalPopup = dynamic(() =>
  import('./molecules/InternationalPopup/InternationalPopup').then(mod => mod.InternationalPopup)
);
const CobrandContainer = dynamic(() =>
  import('./organisms/CobrandContainer/CobrandContainer').then(mod => mod.CobrandContainer)
);
const PointsEarned = dynamic(() => import('./organisms/PointsEarned/PointsEarned').then(mod => mod.PointsEarned));
const CardDetails = dynamic(() => import('./organisms/CardDetails/CardDetails').then(mod => mod.CardDetails));
const CobrandTabContainer = dynamic(() =>
  import('./organisms/CobrandTabContainer/CobrandTabContainer').then(mod => mod.CobrandTabContainer)
);
const PointsDetails = dynamic(() => import('./organisms/PointsDetails/PointsDetails').then(mod => mod.PointsDetails));
const StickyCta = dynamic(() => import('./organisms/StickyCta/StickyCta').then(mod => mod.StickyCta));
const CobrandCarousel = dynamic(() =>
  import('./organisms/CobrandCarousel/CobrandCarousel').then(mod => mod.CobrandCarousel)
);
const CardOverview = dynamic(() => import('./organisms/CardOverview/CardOverview').then(mod => mod.CardOverview));
const AlertBanner = dynamic(() => import('./organisms/AlertBanner/AlertBanner').then(mod => mod.AlertBanner));
const CobrandComparisonTray = dynamic(() =>
  import('./organisms/CobrandComparisonTray/CobrandComparisonTray').then(mod => mod.CobrandComparisonTray)
);
const CardComparison = dynamic(() =>
  import('./organisms/CardComparison/CardComparison').then(mod => mod.CardComparison)
);
const CardComparisonHeader = dynamic(() =>
  import('./organisms/CardComparisonHeader/CardComparisonHeader').then(mod => mod.CardComparisonHeader)
);
const DataCell = dynamic(() => import('./molecules/DataCellComponent/DataCellComponent').then(mod => mod.DataCell));
const CobrandWrapper = dynamic(() =>
  import('./organisms/CobrandWrapper/CobrandWrapper').then(mod => mod.CobrandWrapper)
);
const CtaComponent = dynamic(() => import('./molecules/CtaComponent/CtaComponent').then(mod => mod.CtaComponent));
const CobrandWebSmallBanner = dynamic(() =>
  import('./organisms/CobrandWebSmallBanner/CobrandWebSmallBanner').then(mod => mod.CobrandWebSmallBanner)
);
const PointsCard = dynamic(() => import('./molecules/PointsCard').then(mod => mod.PointsCard));
const InterstitialComponent = dynamic(() =>
  import('./organisms/InterstitialComponent/InterstitialComponent').then(mod => mod.InterstitialComponent)
);

const CobrandVanilaCarousel = dynamic(() =>
  import('./molecules/CobrandVanilaCarousel').then(mod => mod.CobrandVanilaCarousel)
);

const OCountdownEyebrowBanner = dynamic(() =>
  import('./organisms/OCountdownEyebrowBanner').then(mod => mod.OCountdownEyebrowBanner)
);

const MemberNameGreeting = dynamic(() => import('./organisms/MemberNameGreeting').then(mod => mod.MemberNameGreeting));

const CardAwardBadge = dynamic(() =>
  import('./molecules/CardAwardBadge/CardAwardBadge').then(mod => mod.CardAwardBadge)
);

const CobrandOBannerFeature = dynamic(() =>
  import('./organisms/CobrandOBannerFeature/CobrandOBannerFeature').then(mod => mod.CobrandOBannerFeature)
);

const DataTiles = dynamic(() => import('./organisms/DataTiles/DataTiles').then(mod => mod.DataTiles));

export {
  AwardsGallery,
  CardFeatures,
  CobrandContainer,
  PointsEarned,
  CardDetails,
  InternationalPopup,
  CobrandTabContainer,
  PointsDetails,
  StickyCta,
  CobrandCarousel,
  CardOverview,
  CobrandComparisonTray,
  AlertBanner,
  CardComparison,
  CardComparisonHeader,
  DataCell,
  CobrandWrapper,
  CtaComponent,
  CobrandWebSmallBanner,
  PointsCard,
  InterstitialComponent,
  CobrandVanilaCarousel,
  OCountdownEyebrowBanner,
  MemberNameGreeting,
  CardAwardBadge,
  CobrandOBannerFeature,
  DataTiles,
};

export * from './modules/constants';
export * from './modules/utils';
export * from './context/PageContext';
export type { CardAwardBadgeProps } from './molecules/CardAwardBadge/CardAwardBadge.types';
export * from './hooks';
